export const INSPECTION_REPORT_SUBMIT_ERROR_FALLBACK = 'Something went wrong saving the report.';

/** Extract user-facing message from axios-style errors (mutation + catch). */
export function getAxiosErrorMessage(err: unknown, fallback: string = INSPECTION_REPORT_SUBMIT_ERROR_FALLBACK): string {
  if (!err || typeof err !== 'object') return fallback;

  const e = err as {
    code?: string;
    message?: string;
    request?: unknown;
    response?: { status?: number; data?: { errors?: string[]; error?: string; message?: string } };
  };

  // Timeout: axios aborts at its configured timeout. Most common with large media on a weak connection.
  if (e.code === 'ECONNABORTED' || (e.message ?? '').toLowerCase().includes('timeout')) {
    return 'Upload timed out — your photos or videos may be too large, or your connection is weak. Remove some media or move to a stronger signal and try again.';
  }

  if (e.response) {
    // 413 may arrive from our backend guard (JSON body) or a proxy (no JSON body).
    if (e.response.status === 413) {
      return (
        e.response.data?.errors?.[0] ??
        'Your photos and videos are too large to upload. Please remove or shorten some media and try again.'
      );
    }
    const data = e.response.data;
    return data?.errors?.[0] ?? data?.error ?? data?.message ?? fallback;
  }

  // Request was sent but no response came back = network failure (server unreachable, CORS, offline).
  if (e.request) {
    return "Network error — we couldn't reach the server. Check your connection and try again.";
  }

  return fallback;
}
